(() => {
  if (window.quickBrandsLoaded) return;
  window.quickBrandsLoaded = true;

  const LIMIT = 4;

  const QUERY = `query($handle:String!){
    collection(handle:$handle){
      products(first:50,sortKey:BEST_SELLING){
        nodes{vendor}
      }
    }
  }`;

  const norm = value => (value || '').trim().toLowerCase();

  async function init(list) {
    if (list.dataset.loaded) return;
    list.dataset.loaded = '1';

    const root = list.closest('.collection__quick-brands-left');
    const template = root?.querySelector('[data-quick-brand-options]');
    if (!template) return;

    const options = [...template.content.querySelectorAll('[data-vendor]')];

    const lookup = new Map(
      options.map(el => [norm(el.dataset.vendor), el])
    );

    try {
      const response = await fetch(list.dataset.quickBrandsApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: QUERY,
          variables: {
            handle: list.dataset.quickBrands
          }
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const json = await response.json();

      if (json.errors) {
        throw new Error(json.errors[0]?.message || 'GraphQL error');
      }

      const products =
        json.data?.collection?.products?.nodes || [];

      const scores = new Map();

      products.forEach((product, index) => {
        const key = norm(product.vendor);
        const element = lookup.get(key);

        if (!element) return;

        const item = scores.get(key) || {
          element,
          score: 0,
          rank: index
        };

        item.score += products.length - index;
        scores.set(key, item);
      });

      const selected = [];
      const used = new Set();

      const add = element => {
        const key = norm(element.dataset.vendor);

        if (!used.has(key) && selected.length < LIMIT) {
          used.add(key);
          selected.push(element);
        }
      };

      options
        .filter(el => el.classList.contains('is-active'))
        .forEach(add);

      [...scores.values()]
        .sort((a, b) => b.score - a.score || a.rank - b.rank)
        .forEach(item => add(item.element));

      options
        .sort((a, b) => Number(b.dataset.count) - Number(a.dataset.count))
        .forEach(add);

      if (selected.length) {
        list.replaceChildren(
          ...selected.map(el => el.cloneNode(true))
        );
      }

    } catch (error) {
      console.error('Quick brands failed:', error);
    }
  }

  const scan = () => {
    document
      .querySelectorAll('[data-quick-brands]')
      .forEach(init);
  };

  scan();

  new MutationObserver(scan).observe(
    document.querySelector('main') || document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();